import moment, { Moment } from 'moment-timezone';

export const EMPTY_STRING_VALUE = '-';

export const NUMBER_DATE_FORMAT = 'MM/DD/YYYY';
export const STRING_DATE_FORMAT = 'MMMM DD, YYYY';

export const ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const getFullDate = (startDate: string, endDate?: string) =>
  endDate
    ? `${moment(startDate).format(NUMBER_DATE_FORMAT)} - ${moment(endDate).format(NUMBER_DATE_FORMAT)}`
    : moment(startDate).format(NUMBER_DATE_FORMAT);

export const getFormattedDate = (date: string, format?: string): string =>
  moment(date).format(format || STRING_DATE_FORMAT);

export const getStringValue = (value?: string, dateStringFormat: boolean | string = false): string => {
  return value
    ? dateStringFormat
      ? getFormattedDate(value, typeof dateStringFormat === 'string' ? dateStringFormat : undefined)
      : value
    : EMPTY_STRING_VALUE;
};

export const getEventDate = (date: string, format: string): string => moment(date).format(format);

export const getISODateString = (date?: Moment | null, startOfDay = true): string | null =>
  date ? (startOfDay ? date.clone().startOf('day').format(ISO_FORMAT) : date.clone().format(ISO_FORMAT)) : null;

export const getNumberDaysBetweenDates = (firstDate: Date, secondDate: Date): string =>
  String(Math.floor((firstDate.getTime() - secondDate.getTime()) / (1000 * 3600 * 24)));
